<template>
  <div class="ma-4" app>
    <v-container fluid class="full-height">
      <v-row>
        <v-col md="12">
          <DistributorTable />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import DistributorTable from "./Components/DistributorTable";
export default {
  name: "Home",
  components: {
    DistributorTable
  },
  mounted() {
    this.$store.dispatch("getDistributors");
  }
};
</script>
